import { Fragment, lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Box, CircularProgress, CssBaseline } from '@mui/material'

import { publicRoutes } from './routes'
import AutoScrollTop from './components/AutoScrollTop'
import { DetailFood } from './views'
import { useAppContext } from './contexts/AppContext'

const DefaultLayout = lazy(() => import('./layouts/DefaultLayout'))

function App() {
  const { foodID, isBuffetItem } = useAppContext()

  const renderPublicRoutes = () => {
    return publicRoutes.map((route, index) => {
      const { path, component: Page } = route

      let Layout = DefaultLayout

      if (route.layout) {
        Layout = route.layout
      } else if (route.layout === null) {
        Layout = Fragment
      }

      return (
        <Route
          key={index}
          path={path}
          element={
            <Suspense fallback={renderLoadingFallback()}>
              <Layout>
                <Page />
              </Layout>
            </Suspense>
          }
        />
      )
    })
  }

  const renderLoadingFallback = () => {
    return (
      <Box sx={styles.boxLoading}>
        <CircularProgress />
      </Box>
    )
  }

  // Hiển thị popup chi tiết món ăn
  const renderPopupFoodDetail = () => {
    if (foodID) {
      return <DetailFood foodID={foodID} isBuffetItem={isBuffetItem} />
    }

    return null
  }

  return (
    <>
      <CssBaseline />
      <AutoScrollTop>
        <Routes>{renderPublicRoutes()}</Routes>
        {renderPopupFoodDetail()}
      </AutoScrollTop>
    </>
  )
}

export default App

const styles = {
  boxLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    height: '100%',
    width: '100%',
  },
}
